import { render, staticRenderFns } from "./evalaute.vue?vue&type=template&id=8b769d32&scoped=true"
import script from "./evalaute.vue?vue&type=script&lang=js"
export * from "./evalaute.vue?vue&type=script&lang=js"
import style0 from "./evalaute.vue?vue&type=style&index=0&id=8b769d32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b769d32",
  null
  
)

export default component.exports